<template>
  <el-card>
    <div class="toolbar">
      <!-- <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增站点
      </el-button> -->
      <div class="former">
        <el-input
          v-model="form['Name:like']"
          placeholder="站点名称"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <el-cascader
          v-model="area"
          :options="options"
          :props="props"
          clearable
          placeholder="请选择地区"
          :show-all-levels="true"
          :emitPath="false"
        ></el-cascader
        >&nbsp;
        <el-select
          v-model="form.NetWorkingState"
          clearable
          placeholder="联网状态"
        >
          <el-option label="已联网" :value="1"></el-option>
          <el-option label="更换中" :value="2"></el-option>
          <el-option label="已过保" :value="3"></el-option>
        </el-select>
        &nbsp;
        <el-select
          v-model="heartbeat"
          clearable
          placeholder="在线状态"
          style="width: 100px"
        >
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="0"></el-option>
        </el-select>
        &nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Name" label="站点名称"></el-table-column>
      <el-table-column label="所属地区">
        <template slot-scope="scope">
          <span v-if="scope.row.Province">{{ scope.row.Province.Name }}</span>
          <span v-if="scope.row.City">/{{ scope.row.City.Name }}</span>
          <span v-if="scope.row.County">/{{ scope.row.County.Name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="StationType.Name"
        label="站点类型"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="BusinessType.Name"
        label="业务类型"
        width="120"
      ></el-table-column
      ><el-table-column width="120" align="center" label="在线状态">
        <template slot-scope="scope">
          <el-tooltip content="Top center" placement="top" effect="light">
            <div slot="content" v-if="scope.row.HeartBeat === true">在线</div>
            <div slot="content" v-else>离线</div>
            <i
              class="fa fa-wifi fa-lg"
              style="color: #92c655; cursor: pointer"
              v-if="scope.row.HeartBeat === true"
            ></i>
            <i
              class="fa fa-wifi fa-lg"
              style="color: #f0615e; cursor: pointer"
              v-else
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="StationState" label="站点状态" width="120">
        <template slot-scope="{ row }">
          <el-tag v-if="row.NetWorkingState === 1" type="success">
            运行
          </el-tag>
          <el-tag v-if="row.NetWorkingState === 2" type="danger"> 停运 </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="NetWorkingState" label="联网状态" width="120">
        <template slot-scope="{ row }">
          <el-tag v-if="row.NetWorkingState === 1" type="success">
            已联网
          </el-tag>
          <el-tag v-if="row.NetWorkingState === 2" type="warning">
            更换中
          </el-tag>
          <el-tag v-if="row.NetWorkingState === 3" type="danger">
            已过保
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="180" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="bindingPlatform(scope.row)"
            title="绑定平台"
          >
            <i class="fas fa-link"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onSeeItem(scope.row)"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="warning"
            title="站点反控"
            @click="showControl(scope.row)"
            style="width: 33px"
          >
            <i class="fas fa-exchange-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <binding
      v-model="item"
      :visible.sync="bindingVisible"
      @form:saved="getItemList"
    />
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";
import Binding from "./binding.vue";

export default {
  components: {
    ItemForm,
    Binding,
  },
  data() {
    return {
      props: {
        value: "CodeID",
        label: "Name",
        children: "Children",
        checkStrictly: true,
      },
      area: [0, 0, 0],
      options: [],
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        "Name:like": "",
        ProvinceCodeID: "",
        CityCodeID: "",
        CountyCodeID: "",
      },
      heartbeat: "",
      item: this.getEmptyItem(),
      itemVisible: false,
      bindingVisible: false,
    };
  },
  mounted() {
    this.choseArea();
  },
  activated() {
    this.getItemList();
  },
  methods: {
    // 获取
    getItemList() {
      this.loading = true;
      if (this.area[0]) this.form.ProvinceCodeID = this.area[0];
      else this.form.ProvinceCodeID = "";
      if (this.area[1]) this.form.CityCodeID = this.area[1];
      else this.form.CityCodeID = "";
      if (this.area[2]) this.form.CountyCodeID = this.area[2];
      else this.form.CountyCodeID = "";
      this.$axios
        .get("station", {
          params: {
            where: this.form,
            heartbeat: this.heartbeat,
            with: [
              "Code.Contract",
              "Code.Software",
              "BusinessType",
              "Platforms",
              "IpcDevice",
              "StationType",
              "Province",
              "City",
              "County",
            ],
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    bindingPlatform(row) {
      this.item = row;
      this.bindingVisible = true;
    },
    // 编辑
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    // 删除
    onDeleteItem(row) {
      this.$confirm("确定要删除此站点吗？", "提示")
        .then(() => this.$axios.delete(`station/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 新增
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    // item置空
    getEmptyItem() {
      return {
        IpcDevice: {},
      };
    },
    onSeeItem(row) {
      this.$router.push({ name: "PnStationDetail", params: { ID: row.ID } });
    },
    //远程控制
    showControl(row) {
      if (row.Code) {
        this.$router.push(`/pn/manage?code=${row.Code.Name}&id=${row.ID}&name=${row.Name}`);
      } else {
        this.$message.warning("该站点无授权码!");
      }
    },
    choseArea() {
      this.$axios
        .get("area")
        .then((response) => {
          this.options = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
  },
};
</script>
